import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { GetInfoAndPassService } from "src/app/services/get-info-and-pass.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { UserInfoService } from "src/app/services/user-info.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-two-factor-auth",
    templateUrl: "./two-factor-auth.component.html",
    styleUrls: ["./two-factor-auth.component.scss"],
    standalone: false
})
export class TwoFactorAuthComponent implements OnInit {
  @ViewChild("inputElement", { static: true })
  inputElement: ElementRef<HTMLInputElement>;
  public activeTheme: any;
  public mfaStatus: boolean;
  public emailMfaStatus: boolean;
  public subscription: Subscription;
  public subscription2: Subscription;
  public myUser: any;
  public formGroupValues: any;
  public displayNotification: boolean = false;
  public inputValue: any;
  public errorMessage: string;
  public errorMessageMfaNotReceiving: boolean = false;
  public resendCodeDisabled = false;
  public counter = 60;
  public intervalId: ReturnType<typeof setTimeout>;
  public mySharedPlans: {}[];
  public hasPlan;
  public Id;
  public myDelegateUser;
  public directInvoice: any;

  constructor(
    public themeService: ThemeService,
    private sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: ZpDataService,
    private userInfoService: UserInfoService,
    private router: Router,
    private getInfoAndPassService: GetInfoAndPassService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.Id = params.get("Id");
    });
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      this.directInvoice =
        this.api.getRefCodeInfo() && this.api.getRefCodeInfo().directInvoice;
      console.log("direct Invoice -", this.directInvoice);
    });
    await this.getMyUser();
    this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.formGroupValues = data;
      if (this.myUser.firstName == "") {
        this.myUser.firstName = this.formGroupValues.firstName;
      }
      if (this.myUser.lastName == "") {
        this.myUser.lastName = this.formGroupValues.lastName;
      }
      if (this.myUser.dateOfBirth == "") {
        this.myUser.dateOfBirth = this.formGroupValues.dateOfBirth;
      }
      if (this.myUser.hearAboutUs == "") {
        this.myUser.hearAboutUs = this.formGroupValues.hearAboutUs;
      }
    });
    this.getInfoAndPassService.accessUserSection.subscribe((user) => {
      this.myDelegateUser = user;
    });
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.api.getUser();
    }
  }

  getTextWithPhoneNumber() {
    return `We have sent you a code via SMS (${this.inputValue}). Enter it below to verify your mobile number.`;
  }

  async callMFA(inputValue: any) {
    this.inputValue = inputValue;
    if (!inputValue) {
      this.errorMessage = "You must fill your mobile number.";
      return;
    } else {
      this.mfaStatus = true;
      this.myUser.mfaVia = "SMS";
      this.myUser.phoneNumber = this.inputValue;
      await this.api.updateUser(this.myUser);
      await this.api.requestMFACode();
    }
  }

  async switchToEmailMfa(status) {
    if (status === "nosend") {
      this.myUser.mfaVia = "Email";
      await this.api.updateUser(this.myUser);
      this.sendToLocation(this.myUser);
    } else {
      this.myUser.mfaVia = "Email";
      this.requestMfa();
      this.emailMfaStatus = true;
    }
  }

  statusMFA(status) {
    if (status === true) {
      this.displayNotification = true;
      this.api.alertMessage({
        message: "Success!",
        additionalInfo: "MFA number successfully verified!",
      });
    }
  }

  sendToLocation(myUser) {
    if (this.myDelegateUser == "delegate" && this.myUser != undefined) {
      this.router.navigate(["/delegate-home-page"]);
      this.sideNavBarVisibilityService.changeMessage("top");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      if (this.api.getRefCodeInfo() && this.api.getRefCodeInfo().funded) {
        if (myUser.userType == "planHolder") {
          this.router.navigate(["/security-page-sign-up"]);
        } else {
          this.router.navigate(["/home"]);
        }
      } else {
        if (myUser && myUser.userType == "planHolder") {
          this.router.navigate(["/payment-choose-plan"]);
        }
      }

      if (myUser.userType == "professional") {
        if (this.api.getRefCodeInfo().funded) {
          this.router.navigate(["/professional-home-page"]);
        } else {
          this.router.navigate(["/payment-choose-licenses"]);
        }
      }

      if (myUser.userType == "professionalManager") {
        if (this.directInvoice == true) {
          this.router.navigate(["/professional-home-page"]);
        } else {
          this.router.navigate(["/payment-choose-licenses"]);
        }
      }

      if (!myUser.userType) {
        this.router.navigate(["/payment-choose-plan"]);
      }
    }
  }

  async sendANewCode() {
    this.resendCodeDisabled = true;
    this.startCountdown();
    this.errorMessageMfaNotReceiving = true;
    await this.requestMfa();
    alert("Code has been sent again to your mobile.");
  }

  modifyMobileNumber() {
    this.mfaStatus = false;
  }

  startCountdown() {
    this.resendCodeDisabled = true;
    console.log(this.resendCodeDisabled);
    this.intervalId = setInterval(() => {
      this.counter--;

      if (this.counter <= 0) {
        this.stopCountdown();
        this.resendCodeDisabled = false;
      } else {
        this.resendCodeDisabled = true;
      }
    }, 1000);
  }

  stopCountdown() {
    clearInterval(this.intervalId);
    this.counter = 60;
  }

  updatePhoneNumber(status) {
    if (status === true) {
      this.mfaStatus = false;
      this.emailMfaStatus = false;
      this.errorMessageMfaNotReceiving = false;
    }
  }

  switchToEmail(status) {
    if (status === true) {
      this.mfaStatus = false;
      this.emailMfaStatus = true;
      this.myUser.mfaVia = "Email";
      console.log("switchToEmail() myUser: ", this.myUser);
    }
  }

  async requestMfa() {
    await this.api.requestMFACode();
  }

  onSubmit() {
    console.log("onSubmit");
  }
}
